import React, { useState, useEffect, useMemo } from "react";
import { getFolders } from "../../../../api/folderApi";
import { Spinner } from "../../../../components/spinner/Spinner";
import { IPlanarFolder, makeAnalysisForClient } from "./FSPlanarize";
import { FullAnalysisFile } from "./FullAnalysisFile";
import { IFullAnalysisFileRecord } from "./FullAnalysisTypes";
import { IAnalysisFolder } from "./IAnalysisFolder";
import "./ClientFileView.css";

interface IClientFileViewProps{
    clientId: string
}

export const ClientFileView = ({clientId}: IClientFileViewProps)=>{
    const [fileData, setFileData] = useState<IFullAnalysisFileRecord[]>(null);
    useEffect(()=>{
        getFolders().then(response=>{
            return response.json();
        }).then((data: Array<Record<string, IPlanarFolder>>)=>{
            const foldersArray: Array<IPlanarFolder> = data.map(it=>{
                const id = Object.keys(it)[0];
                return {
                    ...it[id],
                    date: new Date(it[id].date),
                    iconIndex: it[id].iconIndex,
                    id
                }
            });
           setFileData(makeAnalysisForClient(clientId, foldersArray));
        });
    }, [clientId]);

    const generatedFile:IAnalysisFolder = useMemo(()=>({
        fileData,
        name: '',
        iconIndex: 0, // Default icon index for the file
        date: new Date(),
        type: 'file'
    }), [fileData]);

    return <>
        {fileData && fileData.length > 0 && <FullAnalysisFile file={generatedFile}></FullAnalysisFile>}
        {!fileData && <Spinner></Spinner>}
        {fileData && fileData.length == 0 && <div className="ClientFileView_emptyData">Not found any analysis data for this client.</div>}
    </>
}